module.exports = __webpack_public_path__ + "static/media/goal-accomplished.5f364906.svg";